import { Button, Paper, Text, Title } from '@mantine/core';
import { seja } from '../seja/seja';
import { TemnoOzadje } from '../postavitev/TemnoOzadje';
import { ObrazecGesla } from '../postavitev/ObrazecGesla';

/** Začasno geslo (nastavil ga je skrbnik) je treba pred delom zamenjati – kot ChangePasswordForm v Swingu. */
export function ZamenjavaGesla() {
  return (
    <TemnoOzadje>
      <Paper radius="lg" p={36} shadow="xl">
        <Title order={2} size="h3">
          Zamenjava gesla
        </Title>
        <Text size="sm" c="dimmed" mb="md">
          Geslo je začasno. Pred nadaljevanjem si nastavite svoje.
        </Text>
        <ObrazecGesla
          oznakaStarega="Začasno geslo"
          gumb="Shrani geslo"
          ob={() => seja.gesloZamenjano()}
          dodatno={
            <Button variant="subtle" onClick={() => void seja.odjava()}>
              Odjava
            </Button>
          }
        />
      </Paper>
    </TemnoOzadje>
  );
}
